import Vue from 'vue'
import Vuex from 'vuex'

// actions
import actions from '@/store/actions'

// mutations
import mutations from '@/store/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    slide: {},
    slides: [],
    idSlide: null,
    audienceId: null,
    audienceName: '',
    audienceEmoji: '',
    audienceQuizTeam: null,
    isAudienceEmojiDisabled: false,
    quizStatus: 1,
    countdownTimeToAnswer: 0,
    logo: null,
    presentation: {},
    showQaSession: false,
    questions: [],
    tabQnaQuestion: 1,
    questionerName: '',
    questionCount: 0,
    socketDisconnect: false,
    disableScrollBody: false,
    audienceEmail: '',
    audienceTeam: '',
  },
  mutations,
  actions,
})
